const Level = {
    methods: {
        level(result, locale = 'fr') {
            switch (result) {
                case ('develop'):
                    return {
                        'style': 'bg-red-100 text-red-600',
                        'text': result
                    };
                    break;
                case ('improve'):
                    return {
                        'style': 'bg-yellow-100 text-yellow-600',
                        'text': result
                    };
                    break;
                case ('maintain'):
                    return {
                        'style': 'bg-green-100 text-green-600',
                        'text': result
                    };
                    break;
            }
        }
    }
}

const Translate = {
    methods: {
        translate(string, locale = 'fr') {
            let parsed = JSON.parse(string)
            return parsed[locale]
        }
    }
}

export {
    Level,
    Translate
}
